// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressBar_progress-bar__rqjFZ {
  --bar-before-width: 0%;
  height: 0.7rem;
  border-radius: 10rem;
  background: #fff;
}

.ProgressBar_progress-bar__rqjFZ::before {
  content: "";
  display: block;
  width: var(--bar-before-width);
  height: 100%;
  border-radius: inherit;
  background-color: var(--primary-color);
  transition: width 0.4s ease-in-out;
}

.ProgressBar_progress-bar--done__jolpx::before {
  background-color: var(--green-dark);
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/ProgressBar/ProgressBar.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".progress-bar {\n  --bar-before-width: 0%;\n  height: 0.7rem;\n  border-radius: 10rem;\n  background: #fff;\n}\n\n.progress-bar::before {\n  content: \"\";\n  display: block;\n  width: var(--bar-before-width);\n  height: 100%;\n  border-radius: inherit;\n  background-color: var(--primary-color);\n  transition: width 0.4s ease-in-out;\n}\n\n.progress-bar--done::before {\n  background-color: var(--green-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progress-bar": `ProgressBar_progress-bar__rqjFZ`,
	"progress-bar--done": `ProgressBar_progress-bar--done__jolpx`
};
export default ___CSS_LOADER_EXPORT___;
